import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store } from './reducers';
import ROOT from './root-client';

const App = () => {
    // Simple version without persistence for debugging the white screen
    return (
        <Provider store={store}>
            <Router
                future={{
                    v7_startTransition: true,
                    v7_relativeSplatPath: true,
                }}
            >
                <ROOT />
            </Router>
        </Provider>
    );
};

export default App;
